import { Reducer } from 'redux';
import { ORDER_TYPES } from '../../helpers/consts';
import { CategoriesState, categoriesTypes } from './types';

const INITIAL_STATE: CategoriesState = {
  categories: {
    data: [],
    pagination: {
      total: 0,
      links: [],
    },
  },
  isLoading: false,
  failure: false,
  activateInactivateFailure: null,
  filterParams: {
    text: '',
    names: [],
    startDate: '',
    endDate: '',
    active: true,
    sort: ORDER_TYPES.ALPHABETICAL_ASCENDING,
  },
  filterModalIsOpen: false,
  saveStatus: '',
  saveError: '',
  category: {
    id: 0,
    name: '',
    created_at: '',
    active: true
  },
};

const reducer: Reducer<CategoriesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        failure: true,
        activateInactivateFailure: true,
      };
    case categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failure: false,
        activateInactivateFailure: false,
      };
    case categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case categoriesTypes.CHANGE_CATEGORY_FILTER_MODAL_STATUS:
      return {
        ...state,
        filterModalIsOpen: action.payload,
      };
    case categoriesTypes.CLEAR_EDIT_CATEGORY:
      return {
        ...state,
        category: INITIAL_STATE.category,
      };
    case categoriesTypes.CLEAR_EDIT_CATEGORY_STEPPER:
      return {
        ...state,
        saveStatus: INITIAL_STATE.saveStatus,
        saveError: INITIAL_STATE.saveError,
      };
    case categoriesTypes.SAVE_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case categoriesTypes.SAVE_CATEGORY_REQUEST_RESPONSE:
      return {
        ...state,
        saveStatus: action.payload.saveStatus,
        saveError: action.payload.saveError,
        isLoading: false,
      };
    case categoriesTypes.SEARCH_CATEGORIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        activateInactivateFailure: null,
      };
    case categoriesTypes.SEARCH_CATEGORIES_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        failure: true,
      };
    case categoriesTypes.SEARCH_CATEGORIES_REQUEST_SUCCESS:
      return {
        ...state,
        categories: {
          data: [...state.categories.data, ...action.payload.data],
          pagination: action.payload.pagination,
        },
        isLoading: false,
        failure: false,
      };
    case categoriesTypes.SEARCH_FIRST_CATEGORIES_REQUEST_SUCCESS:
      return {
        ...state,
        categories: {
          data: action.payload.data,
          pagination: action.payload.pagination,
        },
        isLoading: false,
        failure: false,
      };
    case categoriesTypes.SET_EDIT_CATEGORY:
      return {
        ...state,
        category: {
          ...state.category,
          id: action.payload.id,
          name: action.payload.name,
        },
      };
    case categoriesTypes.UPDATE_CATEGORY_FILTER_PARAMS:
      return {
        ...state,
        isLoading: true,
        filterModalIsOpen: false,
        filterParams: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
